function SvgIrrigationSum(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path d='M12 2.2c-.133 0-.267.025-.4.075-.134.05-.25.116-.35.2-2.433 2.15-4.25 4.15-5.45 6-1.2 1.85-1.8 3.567-1.8 5.15 0 2.517.804 4.513 2.412 5.988C8.02 21.088 9.883 21.824 12 21.824c.33 0 .653-.017.97-.053a5.002 5.002 0 1 1 6.815-6.029c.144-.66.215-1.365.215-2.117 0-1.583-.6-3.3-1.8-5.15-1.2-1.85-3.017-3.85-5.45-6-.1-.084-.216-.15-.35-.2A1.136 1.136 0 0 0 12 2.2zm3 11a4 4 0 1 0 4 4c0-2.209-1.792-4-4-4zm0 2c.22 0 .4.18.4.4v1.2h1.2a.4.4 0 1 1 0 .8h-1.2v1.2a.4.4 0 0 1-.8 0v-1.2h-1.2a.4.4 0 1 1 0-.799h1.2V15.6c0-.22.18-.4.4-.4z' />
    </svg>
  )
}

export default SvgIrrigationSum
